import { axiosClientAdmin } from "@/lib/auth"
import { SearchInput, SearchInputBase } from "../util/types"
import { Comparator, Filter, FilterOperator, PostSearchMonitoringOfficersMonitoringData, PostSearchMonitoringOfficersMonitoringResponse, SortOrder } from "../types.gen"
import { UseQueryOptions } from "@tanstack/react-query"

export type SearchCompanyAgentsInput = SearchInputBase & {
  companyId: string
  searchTerm?: string
  name?: string;
  email?: string
}

export const searchCompanyAgents = async (input: SearchCompanyAgentsInput) => {
  const { companyId, searchTerm, name, email, ...rest } = input
  const pathTpl: PostSearchMonitoringOfficersMonitoringData["url"] = "/Monitoring/companies/{companyId}/users/search"

  const search = new SearchInput({
    sortBy: "name",
    sortDir: SortOrder.Ascending,
    ...rest,
  })

  search.filterFilters.push({
    field: "deletedAt",
    action: Comparator.Eq
  })

  const ors: Filter[] = []

  if (searchTerm) {
    ors.push({
      field: "name",
      action: Comparator.ILike,
      value: searchTerm
    })
  }

  if (name) {
    ors.push({
      field: "name",
      action: Comparator.ILike,
      value: name
    })
  }

  if (ors.length > 0) {
    search.filterFilterGroups.push({
      operator: FilterOperator.Or,
      filters: ors
    })
  }

  const response = await axiosClientAdmin.post<PostSearchMonitoringOfficersMonitoringResponse>(
    pathTpl.replace("{companyId}", companyId),
    null,
    { params: search.toParams() }
  )

  return response.data
}

export const SearchCompanyAgentsQuery = (input: SearchCompanyAgentsInput) => {
  return {
    queryKey: ["monitoring.company.agents.search", input],
    queryFn: () => searchCompanyAgents(input),
  } satisfies UseQueryOptions<PostSearchMonitoringOfficersMonitoringResponse, Error, PostSearchMonitoringOfficersMonitoringResponse>
}